import {Injectable} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {Subject} from 'rxjs';
import {TabCloseEvent} from '../api/tabcloseevent';
import {AppConfig, LayoutState} from "../interfaces/layout.interfaces";
import LogRocket from 'logrocket';

export type MenuMode = 'static' | 'overlay' | 'slim-plus' | 'slim';
export type ColorScheme = 'light' | 'dark';

@Injectable({
    providedIn: 'root',
})
export class LayoutService {
    constructor() {
        LogRocket.init('u5h7hc/sistema-dot', {
            release: '1.0.0',
            dom: {
                textSanitizer: true,
                inputSanitizer: "lipsum"
            },
            browser: {
                urlSanitizer: url => {
                    let sanitizedUrl = url;
                    sanitizedUrl = sanitizedUrl.replace(/usuario=([^&]*)/, 'usuario=**********');
                    sanitizedUrl = sanitizedUrl.replace(/\/usuario\/[^/?]+/, '/usuario/*****')
                    sanitizedUrl = sanitizedUrl.replace(/sessionId=([^&]*)/, 'sessionId=**********');
                    sanitizedUrl = sanitizedUrl.replace(/clave=([^&]*)/, 'clave=**********');
                    sanitizedUrl = sanitizedUrl.replace(/clave=([^&]*)/, 'clave=**********');
                    return sanitizedUrl;
                },
            },
            network: {
                requestSanitizer: request => {
                    if (request.headers['Authorization']) {
                        request.headers['Authorization'] = '';
                    }
                    if (request.url.toLowerCase().indexOf('auth') !== -1) {
                        if (request.body) {
                            const body = JSON.parse(request.body);
                            if ('clave' in body) {
                                delete body.clave;
                            }
                        }
                    }
                    return request;
                },
                responseSanitizer: (response) => {
                    if (response.body?.includes('token') || response.body?.includes('clave')) {
                        delete response.body;
                    }
                    return response;
                },
            }, console: {
                isEnabled: {
                    log: false,
                    info: false,
                    debug: true,
                    error: true,
                    warn: true,
                },
            },
        });
        LogRocket.identify("default-sdt-user", {});
    }

    config: AppConfig = {
        ripple: false,
        inputStyle: 'outlined',
        menuMode: 'slim',
        colorScheme: 'light',
        theme: 'indigo',
        layoutTheme: 'colorScheme',
        scale: 12
    };
    state: LayoutState = {
        staticMenuDesktopInactive: false,
        overlayMenuActive: false,
        profileSidebarVisible: false,
        configSidebarVisible: false,
        staticMenuMobileActive: false,
        menuHoverActive: false
    };
    tabs: MenuItem[] = [];
    private configUpdate = new Subject<AppConfig>();
    private overlayOpen = new Subject<any>();
    private tabOpen = new Subject<MenuItem>();
    private tabClose = new Subject<TabCloseEvent>();
    configUpdate$ = this.configUpdate.asObservable();
    overlayOpen$ = this.overlayOpen.asObservable();
    tabOpen$ = this.tabOpen.asObservable();
    tabClose$ = this.tabClose.asObservable();

    onMenuToggle() {
        if (this.isOverlay()) {
            this.state.overlayMenuActive = !this.state.overlayMenuActive;
            if (this.state.overlayMenuActive) {
                this.overlayOpen.next(null);
            }
        }
        if (this.isDesktop()) {
            this.state.staticMenuDesktopInactive = !this.state.staticMenuDesktopInactive;
        } else {
            this.state.staticMenuMobileActive = !this.state.staticMenuMobileActive;
            if (this.state.staticMenuMobileActive) {
                this.overlayOpen.next(null);
            }
        }
    }

    onOverlaySubmenuOpen() {
        this.overlayOpen.next(null);
    }

    showProfileSidebar() {
        this.state.profileSidebarVisible = true;
    }

    showConfigSidebar() {
        this.state.configSidebarVisible = true;
    }

    isDesktop() {
        return window.innerWidth > 991;
    }

    isOverlay() {
        return this.config.menuMode === 'overlay';
    }

    isSlim() {
        return this.config.menuMode === 'slim';
    }

    isSlimPlus() {
        return this.config.menuMode === 'slim-plus';
    }

    isMobile() {
        return !this.isDesktop();
    }

    onConfigUpdate() {
        this.configUpdate.next(this.config);
    }

    onTabOpen(value: MenuItem) {
        this.tabOpen.next(value);
    }

    openTab(value: MenuItem) {
        this.tabs = [...this.tabs, value];
    }

    onTabClose(value: MenuItem, index: number) {
        this.tabClose.next({tab: value, index: index});
    }

    closeTab(index: number) {
        this.tabs.splice(index, 1);
        this.tabs = [...this.tabs];
    }
}
